import { BuildQueryURLArgs } from '@prismicio/client';
import { SWRResponse } from 'swr';
import useSWRImmutable from 'swr/immutable';

import { PrismicDataType, PrismicReturnType } from '@/models/prismic-hook-types.ts';

import { defaultFetcher, fetchers, isPrismicDataType } from '@/utils/prismic-utils.ts';

// generic hook to handle all prismic calls
// add the calls in the enum 'PrismicReturnTypes', and if needed, add a custom fetcher in 'fetchers' to handle custom logic
export const usePrismic = <T extends PrismicDataType>(
    type: T,
    prismicParams?: Partial<BuildQueryURLArgs>
): SWRResponse<PrismicReturnType[T]> => {
    if (!isPrismicDataType(type)) {
        console.debug(`Error: Invalid Prismic data type: ${String(type)}, will not fetch.`);
    }
    const swrKey: [T, typeof prismicParams] | undefined = isPrismicDataType(type) ? [type, prismicParams] : undefined;

    // Use the specific fetcher if available, otherwise use the default fetcher
    const fetcher = fetchers[type] ?? ((): Promise<PrismicReturnType[T]> => defaultFetcher(type));

    return useSWRImmutable<PrismicReturnType[T]>(swrKey, () => fetcher(type, prismicParams), {
        revalidateOnFocus: false,
        shouldRetryOnError: false,
    });
};
